// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_3Lc0qasnAkaU-W9ognt4Wi"};